export const ESIG_TYPE = 'esig';
